module.exports = __webpack_public_path__ + "static/media/img-0830d46b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gif/h-safari-1.gif
// module id = 5272
// module chunks = 39